import axios from 'axios';

import { SelfMatchAction } from 'components/types';

import { EmployeeCostCenterType } from 'components/enums';

import { ROSTER_REQUESTS_SELF_MATCH } from 'RestAPIs/endpoints';

export type SelfMatchEmployeeTypeAction = {
  employeeCostCenterType: EmployeeCostCenterType;
  action: SelfMatchAction;
};

export const openForSelfMatch = (
  requestIds: number[],
  actions: SelfMatchEmployeeTypeAction[]
) =>
  axios.put(`${ROSTER_REQUESTS_SELF_MATCH}/open`, {
    requestIds,
    employeeCostCenterActions: actions
  });
